"use client";
// Imports
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import Link from "next/link";
import { Placeholder, Img, Content, AddToMyShowButton } from "@/components";
import { TicketPercent, Ruler } from "lucide-react";
import { X } from "lucide-react";
import { DrawerClose } from "@/components/ui/drawer";

export function RideDetails({
  data,
  type,
  userId,
  title,
  categories,
  locations,
  showAddToMyShow,
  image,
  mapIsActive,
}) {
  return (
    <div
      className="grid lg:h-full h-[90dvh] max-h-[90dvh] overflow-y-auto grid-cols-1 lg:overflow-hidden lg:grid-cols-2"
      style={{
        // Red gum accents instead of theme saddle orange
        "--button-background": "137 33 2",
        "--button-hover-background": "137 33 2",
        "--button-foreground": "255 255 255",
      }}
    >
      <div className="order-last col-span-1 w-full h-full rounded-l-lg lg:order-first bg-background text-foreground">
        <div className="flex flex-col justify-between p-4 space-y-6 h-full lg:p-8">
          <div className="pr-2 space-y-5">
            <div className="flex justify-between space-x-5 w-full">
              <h2 className="level-2">{title}</h2>
              <div className="flex justify-end">
                {showAddToMyShow && (
                  <AddToMyShowButton
                    userId={userId}
                    type={type}
                    slug={data.slug}
                    image={image}
                    title={title}
                  />
                )}
              </div>
            </div>

            {categories?.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {categories?.map((category, index) => (
                  <Label dark={false} key={index}>
                    {category?.title}
                  </Label>
                ))}
              </div>
            )}
            {data?.content && (
              <div className="overflow-y-auto text-sm">
                <div className="space-y-3">
                  <Content content={data?.content} />
                </div>
              </div>
            )}
          </div>
          {locations?.length > 0 && mapIsActive && (
            <div className="space-y-3">
              <div className="">
                <p className="pb-2">Where to find</p>
                <div className="flex overflow-y-hidden justify-between items-center w-full">
                  <div className="flex flex-wrap gap-2 justify-start w-full">
                    {locations.map((location, index) => (
                      <Button size="xs" key={index} variant="outline">
                        <Link href={`/map?pin=${location?.slug}`}>
                          {location?.title}
                        </Link>
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="relative col-span-1 w-full h-full">
        <div className="flex absolute right-4 bottom-4 z-50 space-x-3 lg:bottom-8 lg:right-8">
          {data?.min_height && (
            <div className="box-content flex px-3 py-1 space-x-2 rounded-full border-2 text-background border-background bg-foreground">
              <Ruler />
              <span className="font-bold">{data?.min_height}cm</span>
            </div>
          )}
          {data?.price && (
            <div className="box-content flex px-3 py-1 space-x-2 rounded-full border-2 text-background border-background bg-foreground">
              <TicketPercent />
              <span className="font-bold">${data?.price}</span>
            </div>
          )}
        </div>
        <div className="h-[300px] lg:h-full aspect-auto overflow-hidden relative rounded-t-lg lg:rounded-none">
          <DrawerClose asChild>
            <div className="flex absolute top-2 right-2 z-50 justify-center items-center w-8 h-8 rounded-full cursor-pointer lg:hidden bg-foreground text-background">
              <X />
            </div>
          </DrawerClose>
          {image ? (
            <Img fill className={""} data={image} sizes="(max-width: 1024px) 100vw, 500px" />
          ) : (
            <Placeholder type="image-placeholder" />
          )}
        </div>
      </div>
    </div>
  );
}
